import { FEATURES } from '@constants/Text'

/**
 * Gate de PERFIL do cliente final no Financial Planning.
 *
 * ★ Este arquivo deriva de `user.IS_CLIENTE` — o perfil de quem está LOGADO — e
 * de nada mais. O módulo de navegação tem um conjunto parecido de utilitários
 * que modela o PROFISSIONAL entrando na visão de um cliente; eles NÃO servem
 * aqui e reusá-los faria o resultado parecer certo pelo motivo errado. A lista
 * nominal do que não reusar, e o porquê, está em
 * `src/modules/financial-planning/CLAUDE.md` › "Gate de perfil do cliente final".
 *
 * Nada aqui lê feature flag de escritório. É essa ausência que torna
 * "desligar a flag não reabre as rotas bloqueadas" uma propriedade do
 * repositório, e não uma promessa que depende do `if` certo.
 */

/**
 * As únicas rotas do módulo que o cliente final pode enxergar/abrir.
 * A liberação efetiva delas (feature flag do escritório) é responsabilidade
 * de outra camada — aqui só se declara o conjunto.
 */
export const CLIENT_ALLOWED_ROUTE_NAMES = [
  'fp.home',
  'fp.transacoes',
  'fp.objetivos',
]

/**
 * @param {object} user usuário da sessão (`store.getters['user/currentUser']`)
 * @returns {boolean} true quando o perfil da sessão é o do cliente final
 */
export const isCliente = (user) => !!(user && user.IS_CLIENTE)

/**
 * `customPermission` de rota: reprova o cliente final e mantém todos os demais
 * perfis inalterados.
 *
 * A assinatura recebe `{ user, show }` porque é exatamente o objeto que o
 * guard global monta (`router/index.js` → `routeTo.meta.customPermission({
 * user, show })`); reprovar resulta em `next({ name: '404' })`.
 *
 * @param {{user?: object, show?: object}} opts
 * @returns {boolean}
 */
export const blockForCliente = (opts) => !isCliente((opts && opts.user) || {})

/**
 * `customPermission` de `fp.welcome`: COMPÕE com a matriz Cross-Sell já
 * existente em vez de substituí-la — os demais perfis precisam manter o
 * comportamento atual byte a byte.
 *
 * @param {{user?: object, show?: object}} opts
 * @returns {boolean}
 */
export const welcomeAndNotCliente = (opts) => {
  if (!blockForCliente(opts)) return false

  const show = (opts && opts.show) || {}
  return (
    !!(
      show[FEATURES.FINANCIAL_PLANNING] ||
      show[FEATURES.FINANCIAL_PLANNING_SIMULATOR]
    ) || !show[FEATURES.OCULTAR_CROSS_SELL]
  )
}
